import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import VModal from 'vue-js-modal'
import SlideUpDown from 'vue-slide-up-down'
import numeral from "numeral"
import PortalVue from 'portal-vue'
import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'
import './scss/app.scss'

require('./assets/icons')

Vue.config.productionTip = false

Vue.use(VueAxios, axios);
Vue.use(PortalVue)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URI;

Vue.use(MonthPicker)
Vue.use(MonthPickerInput)

Vue.component('b-input', require('./components/Input.vue').default);
Vue.component('b-button', require('./components/Button.vue').default);
Vue.component('b-select', require('./components/Select.vue').default);
Vue.component('b-multiselect', require('./components/Multiselect.vue').default);
Vue.component('b-checkbox', require('./components/Checkbox.vue').default);

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
Vue.use(VModal, { dynamic: true })
Vue.component('slide-up-down', SlideUpDown)

Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'role',
  fetchData: {
    url: 'auth/user?simple',
    method: 'GET',
    enabled: true
  }
})

Vue.filter('percent', function (value) {
  if (isNaN(value)) return ""
  return (value * 100).toFixed(2) + "%"
})

Vue.filter('money', function (value) {
  if (isNaN(value)) return ""
  return numeral(value).format("$0,0.00")
})

Vue.filter('number', function (value) {
  if (isNaN(value)) return ""
  return numeral(value).format("0,0")
})

App.router = router

new Vue(App).$mount('#app');
